/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Usecases_Case_PrefixInputs */

const es_home_usecases_case_prefix = /** @type {(inputs: Home_Usecases_Case_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caso`)
};

const en_home_usecases_case_prefix = /** @type {(inputs: Home_Usecases_Case_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case`)
};

/**
* | output |
* | --- |
* | "Case" |
*
* @param {Home_Usecases_Case_PrefixInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_usecases_case_prefix = /** @type {((inputs?: Home_Usecases_Case_PrefixInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Usecases_Case_PrefixInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_usecases_case_prefix(inputs)
	return en_home_usecases_case_prefix(inputs)
});
export { home_usecases_case_prefix as "home.usecases.case_prefix" }